import { Order, OrderFields } from 'types/order'
import { groupOrders } from './group-orders'

export class AtiGroupSorter {
  static sort(orders: Order[]) {
    const [atiOrders, regularOrders] = groupOrders(orders, AtiGroupSorter.isAtiOrder)

    return [...regularOrders, ...atiOrders]
  }

  static isAtiOrder(order: Order) {
    return String(order[OrderFields.CLIENT_NAME]) === process.env.REACT_APP_ATI_ID_CLIENT
  }
}
